export const hasFocusableElement = (element: HTMLElement) => {
  return !!element.querySelector(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  )
}
